import { Icon as ChakraIcon } from '@chakra-ui/icons';

import type { IconProps } from './types';

export const Icon: React.FC<IconProps> = (props) => <ChakraIcon {...props} />;
